import React from 'react';
import {Box} from '@mui/material';
import {FieldInputProps, FieldMetaProps} from 'formik';
import {Pot} from '../../../schema-types/Pot';
import {withdrawalFieldsType} from './withdrawalFields';
import {getSummary} from '../CreateRecommend/RecommendSourceDestination/naming';
import {getValidation} from '../CreateRecommend/RecommendSourceDestination/validators';
import {WithdrawalDetails} from './WithdrawalSources';
import {getCurrencyFloat} from '../../../utils/currencyFormatter';
import RecommendPlanForm from '../CreateRecommend/RecommendSourceDestination/RecommendPlanForm';

interface WithdrawalSourcePlanFormProps {
  pot: Pot;
  getWithdrawalMessage: (isSelected: boolean) => JSX.Element | null;
  withdrawSourceObj: FieldInputProps<withdrawalFieldsType['source'] | undefined>;
  withdrawSourceMeta: FieldMetaProps<withdrawalFieldsType['source'] | undefined>;
  handleChange: (event: React.ChangeEvent<any> | null, value: string) => void;
}

export const WithdrawalSourcePlanForm: React.FC<WithdrawalSourcePlanFormProps> = ({
  pot,
  getWithdrawalMessage,
  withdrawSourceObj,
  withdrawSourceMeta,
  handleChange,
}) => {
  const isSelected = pot.id === withdrawSourceObj?.value?.id;

  return (
    <RecommendPlanForm
      id={pot.id}
      reccId={pot.originalOvrId ?? null}
      summary={
        <Box display="flex" flexDirection="row">
          {getSummary(pot)}
          {getWithdrawalMessage(isSelected)}
        </Box>
      }
      validation={isSelected ? getValidation(withdrawSourceMeta) : undefined}
      details={
        <WithdrawalDetails pot={pot} maxAmount={getCurrencyFloat(pot.totalValue)} />
      }
      curoId={pot.curoId}
      isSelected={isSelected}
      isSubplan={false}
      handleChange={handleChange}
    />
  );
};
